import { render, staticRenderFns } from "./BzButton.vue?vue&type=template&id=769b30eb&scoped=true&"
import script from "./BzButton.vue?vue&type=script&lang=js&"
export * from "./BzButton.vue?vue&type=script&lang=js&"
import style0 from "./BzButton.vue?vue&type=style&index=0&id=769b30eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b30eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
